const cartCount = class extends HTMLElement {
  constructor () {
    super()
    window.addEventListener('cartAPI', ({ detail: { cartData } }) => {
      if (cartData.item_count === 0) {
        this.innerHTML = cartData.item_count
        return 0
      }

      const childBundleItemsCount = cartData.items
        .filter(item => typeof item.properties?._child_bundle_product !== 'undefined')
        .reduce((pres, cur) => pres + cur.quantity, 0)

      const softBundlesList = []
      const childSoftBundleItemsCount = cartData.items
        .filter(item => typeof item.properties?._child_soft_bundle !== 'undefined')
        .reduce((pres, cur) => {
          if (!softBundlesList.includes(cur.properties._child_soft_bundle)) {
            softBundlesList.push(cur.properties._child_soft_bundle)
            return pres
          }
          return pres + cur.quantity
        }, 0)

      this.innerHTML = cartData.item_count - childBundleItemsCount - childSoftBundleItemsCount
    })
  }
}

if (typeof window.customElements.get('cart-count') === 'undefined') {
  window.customElements.define('cart-count', cartCount)
}

const cartTotal = class extends HTMLElement {
  constructor () {
    super()
    window.addEventListener('cartAPI', ({ detail: { cartData } }) => {
      this.innerHTML = Shopify.formatMoney(cartData.total_price)
    })
  }
}

if(typeof window.customElements.get('cart-total') === 'undefined') {
  window.customElements.define('cart-total', cartTotal)
}

const cartDiscounts = class extends HTMLElement {
  constructor () {
    super()
    window.addEventListener('cartAPI', ({ detail: { cartData } }) => {
      this.innerHTML = Shopify.formatMoney(cartData.total_discount)
    })
  }
}

if(typeof window.customElements.get('cart-discounts') === 'undefined') {
  window.customElements.define('cart-discounts', cartDiscounts)
}
